var _rect, _path, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgViewWeek = function SvgViewWeek(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "#FEF2F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 10.1666H8.5C8.04166 10.1666 7.66666 10.5416 7.66666 11V21C7.66666 21.4583 8.04166 21.8333 8.5 21.8333H11C11.4583 21.8333 11.8333 21.4583 11.8333 21V11C11.8333 10.5416 11.4583 10.1666 11 10.1666ZM22.6667 10.1666H20.1667C19.7083 10.1666 19.3333 10.5416 19.3333 11V21C19.3333 21.4583 19.7083 21.8333 20.1667 21.8333H22.6667C23.125 21.8333 23.5 21.4583 23.5 21V11C23.5 10.5416 23.125 10.1666 22.6667 10.1666ZM14.3333 10.1666H16.8333C17.2917 10.1666 17.6667 10.5416 17.6667 11V21C17.6667 21.4583 17.2917 21.8333 16.8333 21.8333H14.3333C13.875 21.8333 13.5 21.4583 13.5 21V11C13.5 10.5416 13.875 10.1666 14.3333 10.1666Z",
    fill: "#EC7963"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#FEF2F0"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgViewWeek, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/viewWeek.e554397e.svg";
export { ForwardRef as ReactComponent };